export default "__VITE_ASSET__DsII_qnW__ 430w";